// extracted by mini-css-extract-plugin
var _1 = "CityCarousel-jV7TM";
export { _1 as "CityCarousel" }
